import polyline from '@mapbox/polyline';
import circle from '@turf/circle';
import { convertDecimalToHexColor } from './utils';

const decodePolyline = (shape) => {
  if (shape && typeof shape === 'string') {
    const resDecoded = polyline.decode(shape, 6);
    const resDecodedReversed = resDecoded.map(elem => {
      return elem.reverse();
    });
    return resDecodedReversed;
  } else {
    return undefined;
  }
};

export const convertToGeoJsonRoute = (routes, profil) => {
  const decodedRes = decodePolyline(routes.shape);
  if (decodedRes && routes.maneuvers.length > 0) {
    const newGeoJsonSteps = routes.maneuvers.map(elem => {
      return {
        type: 'Feature',
        properties: {
          instruction: elem.instruction,
          type: elem.type,
          name: elem.street_names ? elem.street_names[0] : '',
          length: elem.length,
          time: elem.time,
          acc: elem.access_notes[`acc_${profil}`] ?? 0,
          m: elem.travel_mode,
          t: elem.travel_type,
          c: elem.transit_info ? convertDecimalToHexColor(elem.transit_info.color) : '#9a9a9a',
          has_obstacles: elem.has_obstacles,
          voice_pre: elem.verbal_pre_transition_instruction,
          voice_during: elem.verbal_succinct_transition_instruction,
          voice_post: elem.verbal_post_transition_instruction,
          transit_info: elem.transit_info && {
            ...elem.transit_info, 
            color: convertDecimalToHexColor(elem.transit_info.color), 
            text_color: convertDecimalToHexColor(elem.transit_info.text_color)
          }
        },
        geometry: {
          type: 'LineString',
          coordinates: decodedRes.slice(elem.begin_shape_index, elem.end_shape_index + 1)
        }
      };
    });
    return newGeoJsonSteps;
  } else {
    return undefined; 
  }
};

export const getRadiusOfCenter = (center) => {
  if (center.length > 0) {
    var radius = 500;
    var options = {
      steps: 100, 
      units: 'meters', 
      properties: {
        id: 'user_location_radius'
      }};
    const circleRes = circle(center, radius, options);
    return circleRes;
  } else {
    return;
  }
};